import styled from 'styled-components';

export const Badge = styled.span<{ bg: string; fg: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${({ bg }) => bg};
  color: ${({ fg }) => fg};
  border-radius: 999px;
  padding: 2px 9px;
  font-size: 11px;
  white-space: nowrap;
`;

export const Dot = styled.span<{ color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ color }) => color};
  flex: none;
`;
